document.addEventListener('DOMContentLoaded', function () {
  $('.copy-to-clipboard').on('click', e => {
    var data = $('.country-export-json').val()
    navigator.clipboard.writeText(data).then(
      () => {
        e.target.innerText = 'Copied! 🎉'
      },
      err => {
        console.error('Async: Could not copy text: ', err)
      },
    )
  })

  $('.country-export-json[data-autoselect=true]').on('focus', e => {
    setTimeout(() => {
      e.target.select()
    }, 10)
  })
})
